const maximumDecimalDigits = (value: number, digits: number) =>
  +value.toFixed(digits);

export default maximumDecimalDigits;
